<template>
    <a :href="getLink(item)"
        :target="item.target === 2 ? '_blank': ''"
        :title="item.name"
        class="card-custom-item">
        <h3 v-if="!hideCardTitle"
            class="card-custom-title">
            {{item.title}}
        </h3>
        <picture class="card-custom-bg">
            <source :srcset="item.image.desktop" media="(min-width: 1280px)">
            <source :srcset="item.image.tablet" media="(min-width: 768px)">
            <img :srcset="item.image.mobile" :alt="item.name">
        </picture>
        <span class="card-custom-more card-custom-learn">{{ getTranslateString('Learn More') }}</span>
    </a>
</template>
<script>
    export default {
        name: 'card-custom',
        props: ['item', 'hideCardTitle'],
        methods: {
			getLink(item){
				return (language_is_default?(item.link):('/'+language+"/"+item.link)).replace("//","/");
			}
        },
        
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/cards/card-custom.vue